import { isEmpty } from 'lodash';
import { Divider } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { randomString } from '../../../../../../functions/string.functions.ts';
import { useChatContext } from '../../../../Chat.hook.ts';
import './ChatInfoStaredMessages.styles.scss';
import FavoriteMessage from './components/FavoriteMessage.component.tsx';

export default function ChatInfoStaredMessages() {
  const { favoriteMessages } = useChatContext();
  const { t } = useTranslation(['chat/chat']);

  return (
    <>
      {isEmpty(favoriteMessages) ? (
        <div className="ChatInfoStaredMessages__Content">
          <p>{t('staredMessages.noStaredMessages')}</p>
        </div>
      ) : (
        <div className="ChatInfoStaredMessages__StaredMessages">
          {favoriteMessages.map((favoriteMessage) => (
            <div key={randomString()}>
              <FavoriteMessage key={favoriteMessage.id} {...favoriteMessage} />
              <Divider className="ChatInfoStaredMessages__StaredMessages__Divider" />
            </div>
          ))}
        </div>
      )}
    </>
  );
}
